import React from 'react';
// import { BrowserRouter, Link, Route, Switch, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import './Tutorial.css';

import Navbar from '../Navbar/Navbar'

import { tutorialData } from './TutorialData';


class Tutorial extends React.Component{
	constructor(props) {
		super(props)

		this.state = {
			updateList: [],
			videoData: tutorialData,
			selectedVideo: tutorialData[0]
		}

	}

	// Method to handle video selection
	handleVideoSelect = (video) => {
	  this.setState({
	    selectedVideo: video
	  });
	};

	renderVideoList() {
	  const { selectedVideo } = this.state;

	  return this.state.videoData.map((video, index) => {
	    // Check if this video is the one currently playing
	    const isActive = selectedVideo.link === video.link;

	    return (
	      <div 
	        key={index} 
	        className={`video-card ${isActive ? 'active-card' : ''}`} 
	        onClick={() => this.handleVideoSelect(video)}
	      >
	        <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
	          <path d="M8 5v14l11-7z"/>
	        </svg>
	        <div className="card-text">
	          <span className="card-title">{video.title_brief}</span>
	        </div>
	      </div>
	    );
	  });
	}

  	render(){
  		return(
  			<div class="tutorial-layout-wrapper sub-nav-container page-scroll-container'">
  				<Helmet>
				  <title>Tutorials | DER-CAM</title>
				</Helmet>
			  <header class="tutorial-header-container">
			    <h1>Video Tutorials</h1>
			  </header>

			  <section class="video-data-container">
			    <div class="video-container">
			      <iframe 
			        src={this.state.selectedVideo.link}
			        title="YouTube video player" 
			        frameborder="0" 
			        allowfullscreen>
			      </iframe>
			    </div>
			    <div class="video-title-container">
			      <h3>{this.state.selectedVideo.title_full}</h3>
			    </div>
			    <div class="video-date-container">
			      <p>{this.state.selectedVideo.date}</p>
			    </div>
			    <div class="video-desc-container">
			      <p>{this.state.selectedVideo.desc}</p>
			    </div>
			  </section>

			  <aside class="video-list-container">
			  	<h4 className="list-subtitle">Select Video</h4>
			    {this.renderVideoList()}
			    </aside>
			</div>

  		)
  	}

} 


export default Tutorial;